import { useCallback, useLayoutEffect, useState } from "react";

/** `window.scrollY > 0` — used for themeLock header surface (transparent at page top). */
export default function usePageScrolled(enabled: boolean): boolean {
  const [scrolled, setScrolled] = useState(false);

  const read = useCallback(() => {
    setScrolled(window.scrollY > 0);
  }, []);

  useLayoutEffect(() => {
    if (!enabled) {
      setScrolled(false);
      return;
    }
    read();
    window.addEventListener("scroll", read, { passive: true });
    return () => window.removeEventListener("scroll", read);
  }, [enabled, read]);

  return scrolled;
}
